import { Tab } from '@headlessui/react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import { URL_PARAM_ASSETID } from '$const';
import { PageLayout } from '~components/page/PageLayout';
import { SearchContent } from '~components/search/SearchContent';
import { SearchHeader } from '~components/search/SearchHeader';
import useAppDispatch from '~hooks/useAppDispatch';
import useLabels from '~hooks/useLabels';
import useUrlSearchParam from '~hooks/useUrlSearchParam';
import { ControlActions } from '~store/actions';

export default function SearchPage() {
  const dispatch = useAppDispatch();
  // Read URL param, we need this because we want to switch to the media-library tab when there is a assetId param in the url

  const hasParamAsset = !!useUrlSearchParam(URL_PARAM_ASSETID);
  // prepare statew
  const [selectedTabIndex, setSelectedTabIndex] = useState(hasParamAsset ? 1 : 0);
  // labels
  const { hlSearchResult } = useLabels(['hlSearchResult']);

  // track page view
  const { term } = useParams();
  useEffect(() => {
    const search: OverallSerach = {
      query: term,
    };
    dispatch(ControlActions.overallSearch(search));
  }, [term, dispatch]);

  return (
    <PageLayout title={hlSearchResult} className="page--search" noHeader>
      <Tab.Group selectedIndex={selectedTabIndex} onChange={setSelectedTabIndex}>
        <div className="bg-gray w-full min-h-screen">
          <SearchHeader />
          <SearchContent />
        </div>
      </Tab.Group>
    </PageLayout>
  );
}
